import { Button, Paragraph } from '@quickmd-llc/design-system';
import { useApplicationStore } from '@data';
import type { IntakeQuizForceError } from 'data/slices/devTools';

const MODES: { mode: IntakeQuizForceError; label: string; help: string }[] = [
  { mode: null, label: 'None', help: 'Normal flow' },
  {
    mode: 'boot',
    label: 'Boot failure',
    help: 'Next POST /sessions short-circuits → silent redirect to /schedule + experiment exclusion',
  },
  {
    mode: 'transient',
    label: 'Transient (5xx)',
    help: 'Next POST /responses fakes a 5xx → inline retry notice, question stays',
  },
  {
    mode: 'hard',
    label: 'Hard (4xx)',
    help: 'Next POST /responses fakes a 4xx → "Your session expired" + Start over',
  },
];

/**
 * Dev-tools sidebar section that lets us trigger the three intake-quiz
 * error paths without standing up a misbehaving BE. Read by
 * `IntakeQuizPage` only when `isDevToolsEnabled()` returns true (gated on
 * non-prod hostname), so this never fires on `booking.quick.md`.
 *
 * The flag is intentionally NOT persisted, so a refresh always lands you
 * back in the normal flow.
 */
export function IntakeQuizSection() {
  const intakeQuizForceError = useApplicationStore(
    ({ devTools }) => devTools.intakeQuizForceError,
  );
  const setIntakeQuizForceError = useApplicationStore(
    ({ devTools }) => devTools.setIntakeQuizForceError,
  );

  const activeHelp =
    MODES.find((m) => m.mode === intakeQuizForceError)?.help ?? '';

  return (
    <div>
      <Paragraph size="xs" className="mb-1 font-semibold">
        Intake Quiz — Force Error
      </Paragraph>

      <div className="mb-1 flex flex-wrap gap-2">
        {MODES.map(({ mode, label }) => {
          const isActive = intakeQuizForceError === mode;
          return (
            <Button
              key={label}
              priority={isActive ? 'primary' : 'secondary'}
              size="s"
              type="button"
              onClick={() => setIntakeQuizForceError(mode)}
            >
              {label}
            </Button>
          );
        })}
      </div>

      <Paragraph size="xs" className="text-text-medium">
        {activeHelp}
      </Paragraph>
    </div>
  );
}
